// Item-wise and Bundle discounts on Products (CDN/Invoice/Proforma) are
// percentages (0-100), not currency amounts — this is the single source of
// truth for that math so all three sibling forms (ProformaInvoice.jsx,
// Orders.jsx, ProformaQuote.jsx) compute and display it identically.

// Actual currency amount a discount percentage removes from a gross value.
// Percent is clamped to [0, 100] so it can never discount more than 100%.
export const discountAmountFromPercent = (gross, pct) => {
  const clampedPct = Math.min(Math.max(parseFloat(pct) || 0, 0), 100);
  const grossValue = parseFloat(gross) || 0;
  return (grossValue * clampedPct) / 100;
};

// Sanitizes free-typed discount % input: strips anything that isn't a digit
// or decimal point, caps decimals at 2 places, and clamps to [0, 100].
// Mirrors sanitizeMoneyInput's "always return something usable" approach so
// a keystroke never desyncs the input from what React thinks it set.
export const sanitizePercentInput = (raw) => {
  let sanitized = String(raw).replace(/[^\d.]/g, "");
  const firstDot = sanitized.indexOf(".");
  if (firstDot !== -1) {
    sanitized =
      sanitized.slice(0, firstDot + 1) +
      sanitized.slice(firstDot + 1).replace(/\./g, "").slice(0, 2);
  }
  const numeric = parseFloat(sanitized);
  if (sanitized !== "" && !isNaN(numeric) && numeric > 100) {
    return "100";
  }
  return sanitized;
};
